// extracted by mini-css-extract-plugin
export default {"row":"viewCurrency_row__e-Z0i","col":"viewCurrency_col__20jVt","card":"viewCurrency_card__Aq7gC"};